import { useEffect } from 'react';
import { AudienceNavbar } from '../audience/AudienceNavbar';
import { AudienceFooter } from '../audience/AudienceFooter';
import { useSeoMeta } from '../../hooks/useSeoMeta';

const content = {
  de: {
    title: 'qtplan – Impressum & AGB',
    heading: 'Impressum',
    name: 'Tim Glabisch',
    address: 'Wittelsbachstraße 8A\n40629 Düsseldorf',
    contactHeading: 'Kontakt',
    email: 'qtplan@tim.ainfach.de',
    linksHeading: 'Links',
    agbHeading: 'Allgemeine Geschäftsbedingungen (AGB)',
    agbSections: [
      {
        title: '§ 1 Geltungsbereich',
        paragraphs: [
          'Diese Allgemeinen Geschäftsbedingungen gelten für die Nutzung der Webanwendung qtplan (nachfolgend „Dienst"), betrieben von Tim Glabisch (nachfolgend „Anbieter").',
          'Der Dienst ist eine browserbasierte Planungsanwendung. Alle Daten werden ausschließlich lokal im Browser des Nutzers gespeichert. Es findet keine serverseitige Datenverarbeitung oder -speicherung statt.',
        ],
      },
      {
        title: '§ 2 Leistungsbeschreibung',
        paragraphs: [
          'Der Anbieter stellt den Dienst in der jeweils aktuellen Version unentgeltlich zur Verfügung. Ein Anspruch auf eine bestimmte Verfügbarkeit, Funktionalität oder Weiterentwicklung besteht nicht.',
          'Der Anbieter behält sich vor, den Dienst jederzeit ohne Vorankündigung zu ändern, zu erweitern, einzuschränken oder einzustellen.',
        ],
      },
      {
        title: '§ 3 Nutzung des Dienstes',
        paragraphs: [
          'Die Nutzung des Dienstes erfordert keine Registrierung und keinen Account. Der Nutzer ist selbst für die Sicherung seiner lokal gespeicherten Daten verantwortlich.',
          'Der Nutzer verpflichtet sich, den Dienst nicht für rechtswidrige Zwecke zu verwenden.',
        ],
      },
      {
        title: '§ 4 Haftungsausschluss',
        paragraphs: [
          'Der Dienst wird „wie besehen" ohne jegliche Gewährleistung bereitgestellt. Der Anbieter übernimmt keine Gewähr für die Richtigkeit, Vollständigkeit, Zuverlässigkeit oder Aktualität des Dienstes.',
          'Die Haftung des Anbieters für Schäden aus der Nutzung des Dienstes ist — soweit gesetzlich zulässig — ausgeschlossen. Dies gilt insbesondere für:\n• Datenverlust oder Beschädigung lokal gespeicherter Daten\n• Ausfälle, Unterbrechungen oder Fehler des Dienstes\n• Schäden die durch die Nutzung oder Nichtnutzung des Dienstes entstehen\n• Entgangenen Gewinn und mittelbare Schäden',
          'Bei der Verletzung wesentlicher Vertragspflichten (Kardinalpflichten) haftet der Anbieter bei leichter Fahrlässigkeit nur für den vorhersehbaren, vertragstypischen Schaden. Wesentliche Vertragspflichten sind solche, deren Erfüllung die ordnungsgemäße Durchführung des Vertrages überhaupt erst ermöglicht und auf deren Einhaltung der Nutzer regelmäßig vertrauen darf.',
          'Die vorstehenden Haftungsbeschränkungen gelten nicht für Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit, nicht für Schäden die auf einer vorsätzlichen oder grob fahrlässigen Pflichtverletzung des Anbieters beruhen und nicht für Ansprüche nach dem Produkthaftungsgesetz.',
        ],
      },
      {
        title: '§ 5 Datenschutz',
        paragraphs: [
          'Der Dienst speichert keine personenbezogenen Daten auf Servern des Anbieters. Alle vom Nutzer eingegebenen Daten werden ausschließlich lokal im Browser des Nutzers verarbeitet und gespeichert (LocalStorage/IndexedDB).',
          'Der Anbieter erhebt keine Nutzungsdaten, setzt keine Cookies und verwendet keine Tracking- oder Analyse-Tools.',
        ],
      },
      {
        title: '§ 6 Urheberrecht',
        paragraphs: [
          'Die Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des Anbieters.',
        ],
      },
      {
        title: '§ 7 Änderung der AGB',
        paragraphs: [
          'Der Anbieter behält sich vor, diese AGB jederzeit zu ändern. Die jeweils aktuelle Fassung ist über die Webseite abrufbar. Mit der weiteren Nutzung des Dienstes nach Veröffentlichung geänderter AGB akzeptiert der Nutzer die Änderungen. Da der Dienst keine Accounts verwendet, ist eine individuelle Benachrichtigung nicht möglich.',
        ],
      },
      {
        title: '§ 8 Schlussbestimmungen',
        paragraphs: [
          'Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts (CISG).',
          'Ist der Nutzer Kaufmann, juristische Person des öffentlichen Rechts oder öffentlich-rechtliches Sondervermögen, ist ausschließlicher Gerichtsstand für alle Streitigkeiten aus diesem Vertragsverhältnis Düsseldorf. Im Übrigen gelten die gesetzlichen Bestimmungen zum Gerichtsstand.',
          'Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, so bleibt die Wirksamkeit der übrigen Bestimmungen davon unberührt.',
          'Stand: März 2026',
        ],
      },
    ],
  },
  en: {
    title: 'qtplan – Legal Notice & Terms',
    heading: 'Legal Notice',
    name: 'Tim Glabisch',
    address: 'Wittelsbachstraße 8A\n40629 Düsseldorf\nGermany',
    contactHeading: 'Contact',
    email: 'qtplan@tim.ainfach.de',
    linksHeading: 'Links',
    agbHeading: 'Terms and Conditions',
    agbSections: [
      {
        title: '§ 1 Scope',
        paragraphs: [
          'These Terms and Conditions apply to the use of the web application qtplan (hereinafter "Service"), operated by Tim Glabisch (hereinafter "Provider").',
          'The Service is a browser-based planning application. All data is stored exclusively in the user\'s browser locally. No server-side data processing or storage takes place.',
        ],
      },
      {
        title: '§ 2 Description of Service',
        paragraphs: [
          'The Provider makes the Service available free of charge in its current version. There is no entitlement to any particular availability, functionality, or further development.',
          'The Provider reserves the right to modify, expand, restrict, or discontinue the Service at any time without prior notice.',
        ],
      },
      {
        title: '§ 3 Use of the Service',
        paragraphs: [
          'Use of the Service does not require registration or an account. The user is solely responsible for backing up locally stored data.',
          'The user agrees not to use the Service for any unlawful purposes.',
        ],
      },
      {
        title: '§ 4 Disclaimer of Liability',
        paragraphs: [
          'The Service is provided "as is" without any warranty. The Provider does not warrant the accuracy, completeness, reliability, or timeliness of the Service.',
          'The Provider\'s liability for damages arising from the use of the Service is excluded to the fullest extent permitted by law. This applies in particular to:\n• Loss or corruption of locally stored data\n• Outages, interruptions, or errors of the Service\n• Damages arising from the use or inability to use the Service\n• Lost profits and indirect damages',
          'In the event of a breach of material contractual obligations (cardinal duties), the Provider\'s liability for slight negligence is limited to foreseeable damages typical for this type of contract. Material contractual obligations are those whose fulfilment is essential for the proper performance of the contract and on whose compliance the user may regularly rely.',
          'The above limitations of liability do not apply to damages resulting from injury to life, body, or health, to damages based on intentional or grossly negligent breach of duty by the Provider, or to claims under the German Product Liability Act (Produkthaftungsgesetz).',
        ],
      },
      {
        title: '§ 5 Data Protection',
        paragraphs: [
          'The Service does not store any personal data on the Provider\'s servers. All data entered by the user is processed and stored exclusively in the user\'s browser locally (LocalStorage/IndexedDB).',
          'The Provider does not collect usage data, does not set cookies, and does not use any tracking or analytics tools.',
        ],
      },
      {
        title: '§ 6 Copyright',
        paragraphs: [
          'The content and works on these pages are subject to German copyright law. Reproduction, editing, distribution, and any kind of exploitation outside the limits of copyright law require the written consent of the Provider.',
        ],
      },
      {
        title: '§ 7 Changes to Terms',
        paragraphs: [
          'The Provider reserves the right to amend these Terms at any time. The current version is available on the website. By continuing to use the Service after amended Terms have been published, the user accepts the changes. As the Service does not use accounts, individual notification is not possible.',
        ],
      },
      {
        title: '§ 8 Final Provisions',
        paragraphs: [
          'The laws of the Federal Republic of Germany shall apply, excluding the UN Convention on Contracts for the International Sale of Goods (CISG).',
          'If the user is a merchant (Kaufmann), a legal entity under public law, or a special fund under public law, the exclusive place of jurisdiction for all disputes arising from this contractual relationship shall be Düsseldorf, Germany. In all other cases, the statutory provisions regarding jurisdiction shall apply.',
          'Should individual provisions of these Terms be or become invalid, this shall not affect the validity of the remaining provisions.',
          'Last updated: March 2026',
        ],
      },
    ],
  },
} as const;

export function ImpressumPage({ lang }: { lang: 'de' | 'en' }) {
  const t = content[lang];

  const otherLang = lang === 'de' ? 'en' : 'de';
  useSeoMeta({
    title: t.title,
    description: lang === 'de' ? 'Impressum und AGB von qtplan – Tim Glabisch, Düsseldorf.' : 'Legal notice and terms of service for qtplan – Tim Glabisch, Düsseldorf, Germany.',
    lang,
    path: `/${lang}/legal/impressum`,
    alternatePath: `/${otherLang}/legal/impressum`,
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [lang]);

  const linkStyle = { color: 'var(--landing-accent)' };

  return (
    <div className="landing-root">
      <AudienceNavbar lang={lang} slug="impressum" basePath="legal" />

      <article className="audience-narrative" style={{ paddingTop: '8rem' }}>
        <h1>{t.heading}</h1>

        <p style={{ whiteSpace: 'pre-line' }}>{t.name}<br />{t.address}</p>

        <h2 style={{ marginTop: '2rem' }}>{t.contactHeading}</h2>
        <p>
          E-Mail: <a href={`mailto:${t.email}`} style={linkStyle}>{t.email}</a>
        </p>

        <h2 style={{ marginTop: '2rem' }}>{t.linksHeading}</h2>
        <ul style={{ listStyle: 'none', padding: 0, display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
          <li><a href="https://github.com/timglabisch" target="_blank" rel="noopener noreferrer" style={linkStyle}>GitHub</a></li>
          <li><a href="https://x.com/timglabisch" target="_blank" rel="noopener noreferrer" style={linkStyle}>X (Twitter)</a></li>
          <li><a href="https://www.linkedin.com/in/tim-glabisch-978412264/" target="_blank" rel="noopener noreferrer" style={linkStyle}>LinkedIn</a></li>
        </ul>

        <hr style={{ border: 'none', borderTop: '1px solid var(--landing-border)', margin: '3rem 0' }} />

        <h2 id="agb">{t.agbHeading}</h2>
        {t.agbSections.map((section) => (
          <div key={section.title} style={{ marginTop: '1.5rem' }}>
            <h3 style={{ fontSize: '1rem', fontWeight: 600 }}>{section.title}</h3>
            {section.paragraphs.map((p, i) => (
              <p key={i} style={{ whiteSpace: 'pre-line' }}>{p}</p>
            ))}
          </div>
        ))}
      </article>

      <AudienceFooter lang={lang} currentSlug="impressum" basePath="legal" />
    </div>
  );
}
